module.exports = __webpack_public_path__ + "static/media/malcolm.5399860f.jpg";